import pathsConfig from './paths'
import apiConfig from './api'
import siteConfig from './site'
import sentryConfig from './sentry'

const config = {
  paths: pathsConfig,
  api: apiConfig,
  site: siteConfig,
  sentry: sentryConfig
}

export default config
